export default __webpack_public_path__ + "static/media/testbanner1400.f691a31a.png";